import React, { FC, PropsWithChildren } from 'react'

const Label: FC<PropsWithChildren> = ({ children }) => <p className="label px-0">{children}</p>

export default Label
